<nav class="head-nav mb-4">
    <div class="nav-container">
        <div>
            <h2>{{ "availabilty.Days Off" | translate }}</h2>
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a [routerLink]='["/admin"]'>{{ "general.Home" | translate }}</a>
                </li>
                <li class="breadcrumb-item">{{"publish.Availability" | translate}}</li>
                <li class="breadcrumb-item">{{ "availabilty.Days Off" | translate }}</li>
            </ol>
        </div>
    </div>
</nav>

<div class="page">
    <div class="page-filters mb-3 mt-0 with-info">
        <div class="sort-item">
            <span class="count-page font-16 mr-2 fontMedium">
                {{'availabilty.Days Off' | translate}}
            </span>
            <span class="info">
                {{"availabilty.Days when the restaurant will be closed and reservations will not be available (i.e. holidays, restaurant closed for maintenance or etc.)" | translate}}
            </span>
        </div>

        <div class="filters-container" *ngIf="recordsData?.canAdd">
            <div class="create-item">
                <a class="btn-light" mat-stroked-button (click)="openDayForm()">
                    <img src="./assets/images/icons/plus-ic.svg">
                    <span>{{"availabilty.Add New" | translate}}</span>
                </a>
            </div>
        </div>

    </div>

    <div *ngIf='dataLoading' class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>


    <ng-container *ngIf='!dataLoading'>
        <div *ngIf="recordsData?.pageData && recordsData?.pageData?.length; else dataEmpty">
            <div class="table-responsive table-container ">
                <table class="table table-primary bordered">
                    <thead>
                        <tr>
                            <th class="font-14 fontMedium" style="width: 15%;">{{'availabilty.Title' | translate}}</th>
                            <th class="font-14 fontMedium">{{'availabilty.Recurring Every Year?' | translate}}</th>
                            <th class="font-14 fontMedium">{{'availabilty.Start & End Dates' | translate}}</th>
                            <th class="font-14 fontMedium">{{'restaurant.Branches' | translate}}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of recordsData?.pageData">
                            <td>
                                <span class="font-14 fontMedium" [matTooltip]="item.title">
                                    {{item.title | slice:0:10}} {{ item.title.length > 10 ? '...' : ''}}
                                </span>
                            </td>
                            <td class="font-14 fontRegular">
                              {{(item.recurringYear? 'swalMsg.Yes':'swalMsg.No') | translate}}
                            </td>
                            <!-- <td class="font-14 fontRegular">{{item.startAndEnd}}
                            </td> -->
                            <td class="font-14 fontRegular text-nowrap">
                              {{item.start | date:(item.recurringYear ? 'd MMMM':'d MMMM, y')}}
                              <span *ngIf="item.end" class="grey-color font-14 fontRegular mx-1">{{ 'content2.to' | translate }}</span>
                              {{item.end | date:(item.recurringYear ? 'd MMMM':'d MMMM, y')}}

                              <span *ngIf="item.recurringYear">({{'availabilty.Yearly' | translate}})</span>
                        </td>
                            <td class="font-14 fontMedium text-wrap">
                              <span class="text-nowrap" *ngFor="let branch of item.branches | slice: 0: 3; let i = last">
                                {{branch.title}}
                                <span *ngIf="!i">/</span>
                              </span>
                              <span class="text-nowrap" *ngIf="item.branches.length > 2">/ + {{item.branches.length - 2}}</span>
                            </td>
                            <td>
                                <div class="btn-actions">
                                    <button type="button" mat-icon-button (click)="changeStatus(item.id, false)"
                                        [matTooltip]="'general.Deactivate' | translate" *ngIf="item.canEditStatus && item.isActive">
                                        <mat-icon>pause</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button (click)="changeStatus(item.id, true)"
                                        [matTooltip]="'general.Activate' | translate" *ngIf="item.canEditStatus && !item.isActive">
                                        <mat-icon>play_arrow</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button [matTooltip]="'general.Edit' | translate"
                                        (click)="openDayForm(item)" *ngIf="item.canEdit">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button [matTooltip]="'general.Delete' | translate"
                                        (click)="deleteRecord(item.id)" *ngIf="item.canDelete">
                                        <mat-icon class="delete-icon">delete</mat-icon>
                                    </button>

                                </div>
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>

            <div class="pagination-container" *ngIf="recordsData && (pageCount > 1 || recordsData['totalCount'] > pageSize)">
                <mat-paginator [length]="recordsData['totalCount']" [pageSize]="filterModel.pageSize"
                    [pageSizeOptions]="[5, 10, 20]" (page)="getAll($event)" [pageIndex]="pageIndex"></mat-paginator>
            </div>

        </div>

        <ng-template #dataEmpty>
            <empty-state [title]='"general.No Data Found" | translate'></empty-state>
        </ng-template>
    </ng-container>
</div>
